import { useCallback } from 'react'
import { useSettingsStore, type SidebarTableSort } from '@features/settings/stores/useSettingsStore'
import { useUpdateOwnPreference } from '@features/settings/hooks/useUpdateOwnPreference'

/**
 * The table list's folders and sort, shared by the rail's Tables drawer and
 * the Tables panel. Both are the user's own Preferences.
 */
export function useTableListPreferences() {
  const foldersEnabled = useSettingsStore((s) => s.sidebarTableFolders)
  const tableSort = useSettingsStore((s) => s.sidebarTableSort)
  const updateOwnPreference = useUpdateOwnPreference()

  const setFoldersEnabled = useCallback(
    (enabled: boolean) => {
      if (enabled === useSettingsStore.getState().sidebarTableFolders) return
      void updateOwnPreference('sidebar_table_folders', 'sidebarTableFolders', enabled)
    },
    [updateOwnPreference]
  )

  const setTableSort = useCallback(
    (sort: SidebarTableSort) => {
      if (sort === useSettingsStore.getState().sidebarTableSort) return
      void updateOwnPreference('sidebar_table_sort', 'sidebarTableSort', sort)
    },
    [updateOwnPreference]
  )

  return { foldersEnabled, tableSort, setFoldersEnabled, setTableSort }
}
